import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

//import images
import { axiosIns } from "../../utils";
import { useLogout } from "../../hooks/useAuth";
import { getStoredAuthUser } from "../../utils/authUser";
import UserProfileAvatarWithFallback from "./UserProfileAvatarWithFallback";

const DEFAULT_USER_AVATAR =
  "https://prod.leconseillerdubtp.com/medias/default/user.png";

const ProfileDropdown = (props) => {
  const logout = useLogout();
  const authUser = getStoredAuthUser();
  const userId = authUser?.id;

  const [info, setInfo] = useState({});
  const [profile, setProfile] = useState({});

  const fetchData = async (id) => {
    try {
      const response = await axiosIns.get(`/profile/${id}/`);
      setInfo(response.data);
      setProfile(response.data?.profile);
    } catch (_) {
      // ignore
    }
  };

  useEffect(() => {
    if (!userId) return;
    fetchData(userId);
  }, [userId]);

  const handleLogOut = () => {
    logout();
  };

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const avatarDisplayName =
    [profile.first_name, profile.last_name].filter(Boolean).join(" ").trim() ||
    info.username ||
    "";

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <UserProfileAvatarWithFallback
              picture={profile.profile_pic}
              name={avatarDisplayName}
              defaultUrl={DEFAULT_USER_AVATAR}
              t={props.t}
              imageClassName="rounded-circle header-profile-user"
              imageStyle={{
                objectFit: "cover",
                objectPosition: "center center",
              }}
              fallbackWrapperClassName="flex-shrink-0 header-profile-user d-flex"
              fallbackTextClassName="avatar-title bg-soft-success text-success rounded-circle d-flex align-items-center justify-content-center"
              fallbackWrapperStyle={{ width: 32, height: 32 }}
              fallbackTextStyle={{
                width: 32,
                height: 32,
                fontSize: "14px",
                fontWeight: 600,
              }}
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {info.username}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {profile.user_type === "particular"
                  ? "Particulier"
                  : profile.user_type === "professional"
                  ? "Professionnel du BTP"
                  : profile.user_type === "organism"
                  ? "Organisme"
                  : profile.user_type === "bank"
                  ? "Banque"
                  : profile.user_type === "expert"
                  ? "Expert"
                  : profile.user_type === "commite"
                  ? "Commité"
                  : profile.user_type === "assistant"
                  ? "Assistant"
                  : profile.user_type === "admin"
                  ? "Administrateur"
                  : "Collaborateur"}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">
            {props.t("Bienvenue")} {profile.first_name || profile.username} !
          </h6>
          <DropdownItem href="/pages-profile">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle"> {props.t("Profil")}</span>
          </DropdownItem>
          <DropdownItem onClick={handleLogOut}>
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              {props.t("Déconnexion")}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileDropdown.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(ProfileDropdown));
